import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect, useDispatch } from 'react-redux';
import { ButtonGroup, Button, SegmentLoader, Row, Col } from '@si-armes/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import moment from 'moment';
import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';

import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_IDENTITE_URL,
    API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL,
    API_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
    CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
    CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
    CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
} from 'constants/apiUrls.constants';
import { MESSAGE_DATE_INVALIDE } from 'constants/messagePersonalise.constants';

import { CLEAR_ALERTES } from 'utils/utils';
import {
    KEY_DETENTEUR_METIER_PHYSIQUE,
    KEY_DETENTEUR_COLLECTIONNEUR_MORALE,
} from 'pages/compte/creer/etape-1/components/statut/StatutCompte.constante';

import formaterCreationIdentite from './FormaterCreationIdentite';
import formaterFichiersPiecesIdentiteEtape1 from './FormaterFichiersPiecesIdentiteEtape1';
import formaterFichierCarteCollectionneur from './FormaterFichierCarteCollectionneur';
import { hideAllNotification } from '../../../../../../store/alertes/alertesReducer';
import CompteIdentiteChamps from './CompteIdentiteChamps';
import ChampsCarteCollectionneur from './ChampsCarteCollectionneur';
import CreerCompteAdresse from '../adresse/CreerCompteAdresse';

// @todo Refacto le composant (Utiliser le validator de ReactHookForm, éviter les setValue, trigger
const CreerCompteIdentiteMetierAsso = ({
    statutCompteMetierAsso,
    statutMetierAsso,
    dataIdentiteMetierAsso,
    postApi,
    isLoading,
    retourEtape,
    erreur,
    message,
    data,
    uuidBrouillon,
    reinitialiseApi,
    isLoadingRenseignerPiecesIdentite,
    erreurRenseignerPiecesIdentite,
    dataRenseignerPiecesIdentite,
    isLoadingPermisDeChasse,
    isLoadingValidationPermisChasser,
    isLoadingVersoLicenceSki,
    isLoadingVersoLicenceBallTrap,
    isLoadingCarteCollectionneur,
    erreurCarteCollectionneur,
    dataRenseignerCarteCollectionneur,
    clearAlertes,
    dataCodePostal,
    setEtapeIdentiteMetierAsso,
    motifs,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: {
            paysNaissance: '75',
            ...dataIdentiteMetierAsso,
        },
    });

    const dispatch = useDispatch();
    const { handleSubmit, getValues, watch, formState, trigger, setValue } = hookForm;

    const IS_COLLECTIONNEUR_MORALE = statutMetierAsso === KEY_DETENTEUR_COLLECTIONNEUR_MORALE;

    const [dataIdentite, setDataIdentite] = useState();
    const [isSuccessSubmitCreerCompteAdresse, setIsSuccessSubmitCreerCompteAdresse] =
        useState(false);

    const [isLoadingApiCreerCompteAdresse, setIsLoadingApiCreerCompteAdresse] = useState(false);

    useEffect(() => {
        if (dataIdentiteMetierAsso) {
            setValue('piecesIdentite', dataIdentiteMetierAsso.piecesIdentite);

            setValue('numeroGuichetUnique', dataIdentiteMetierAsso.numeroGuichetUnique);

            setValue('carteCollectionneur', dataIdentiteMetierAsso.carteCollectionneur);
            setValue('numeroCarteCollectionneur', dataIdentiteMetierAsso.numeroCarteCollectionneur);
            setValue(
                'dateDelivranceCarteCollectionneur',
                dataIdentiteMetierAsso.dateDelivranceCarteCollectionneur,
            );
        }
    }, []);

    async function postPiecesIdentite() {
        (await formaterFichiersPiecesIdentiteEtape1(dataIdentite)).forEach((value, index) => {
            postApi(
                usagerClientReducer,
                API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL.replace(
                    '{index}',
                    index + 1,
                ),
                {
                    pieceIdentite: value,
                    key: index + 1,
                    uuidBrouillon,
                },
                CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2,
            );
        });
    }

    async function postCarteCollectionneur() {
        await postApi(
            usagerClientReducer,
            API_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL,
            {
                carteCollectionneur: await formaterFichierCarteCollectionneur(dataIdentite),
                numero: dataIdentite.numeroCarteCollectionneur,
                dateDelivrance: dataIdentite.dateDelivranceCarteCollectionneur,
                uuidBrouillon,
            },
            CONTEXT_ENREGISTRER_CARTE_COLLECTIONNEUR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE,
        );
    }

    const validateDate = (dateValue) => {
        const dateSplit = dateValue.split('/');
        const dateExistante = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
        if (
            (dateSplit &&
                moment(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`).diff(moment()) > 0) ||
            (dateSplit[1] !== '00' &&
                dateSplit[0] !== '00' &&
                (dateExistante.getFullYear() !== parseInt(dateSplit[2], 10) ||
                    dateExistante.getMonth() + 1 !== parseInt(dateSplit[1], 10) ||
                    dateExistante.getDate() !== parseInt(dateSplit[0], 10)))
        ) {
            return MESSAGE_DATE_INVALIDE;
        }
        return null;
    };

    function conditionPourPasserEtapeSuivante() {
        const informationsIdentiteEnvoyee = isLoading === false && data && !erreur;

        const piecesIdentiteEnvoyee =
            !isLoadingRenseignerPiecesIdentite &&
            dataRenseignerPiecesIdentite &&
            !erreurRenseignerPiecesIdentite;

        if (IS_COLLECTIONNEUR_MORALE) {
            const carteCollectionneurEnvoyee =
                !isLoadingCarteCollectionneur &&
                dataRenseignerCarteCollectionneur &&
                !erreurCarteCollectionneur;

            return (
                piecesIdentiteEnvoyee &&
                informationsIdentiteEnvoyee &&
                carteCollectionneurEnvoyee &&
                isSuccessSubmitCreerCompteAdresse
            );
        }

        return (
            piecesIdentiteEnvoyee &&
            informationsIdentiteEnvoyee &&
            isSuccessSubmitCreerCompteAdresse
        );
    }

    useEffect(() => {
        if (conditionPourPasserEtapeSuivante()) {
            setEtapeIdentiteMetierAsso(getValues());
        }
    }, [data, isSuccessSubmitCreerCompteAdresse]);

    // on mount et unmount
    useEffect(() => {
        window.scrollTo(0, 0);
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_IDENTITE);
        return () => {
            reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_IDENTITE);
        };
    }, []);

    // --------- GESTION DES ERREURS DE CHAMPS --------------

    // Revalider les champs prénoms quand un prénom est modifié.
    useEffect(() => {
        trigger(['prenomDeux', 'prenomTrois', 'prenomQuatre', 'prenomUsuel']);
    }, [
        watch('prenomUn'),
        watch('prenomDeux'),
        watch('prenomTrois'),
        watch('prenomQuatre'),
        watch('prenomUsuel'),
    ]);

    // Revalider le pays de Naissance
    useEffect(() => {
        trigger(['paysNaissance']);
    }, [watch('paysNaissance')]);

    // --------- GESTION DE LA VALIDATION ET ENVOI DU FORMULAIRE --------------
    // A REFACTO => Utiliser react hook form
    const hasFormValid = () => {
        let formulaireEstValide = formState.isValid;

        // verification de la pièce d'identité;
        formulaireEstValide =
            formulaireEstValide &&
            getValues('piecesIdentite') &&
            getValues('piecesIdentite').length > 0;

        if (IS_COLLECTIONNEUR_MORALE) {
            formulaireEstValide =
                formulaireEstValide &&
                watch('numeroCarteCollectionneur') &&
                watch('dateDelivranceCarteCollectionneur') &&
                getValues('carteCollectionneur') &&
                getValues('carteCollectionneur').length > 0;
        }

        return (
            formulaireEstValide && (watch('typeEtNomDeVoie') || watch('lieuDit')) && dataCodePostal
        );
    };

    useEffect(() => {
        const envoyerRequetes = async () => {
            // Appels successifs et controlés pour éviter un chevauchement
            // du header provoquant une 403 liée au CSRF cookie
            if (dataIdentite?.piecesIdentite) {
                await postPiecesIdentite();
            }

            if (dataIdentite?.carteCollectionneur) {
                await postCarteCollectionneur();
            }
        };

        if (!isLoading && data && !erreur) {
            envoyerRequetes();
        }
    }, [isLoading, data, erreur, dataIdentite]);

    const onSubmit = async (dataForm) => {
        dispatch({ type: CLEAR_ALERTES });
        window.scrollTo(0, 0); // Remonte la page en haut
        setDataIdentite(dataForm);
        const dataFormat = await formaterCreationIdentite(dataForm, uuidBrouillon);

        clearAlertes();
        // Envoi principal du formulaire
        await postApi(
            usagerClientReducer,
            API_COMPTE_CREER_IDENTITE_URL,
            {
                ...dataFormat,
                typeStatut: 'metier.association',
                subTypeStatut: statutCompteMetierAsso?.typeMetierAssociation,
            },
            CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
        );
    };

    const renderMessage = (msg) => {
        return msg.split('\n').map((line) => <p key={line}>{line}</p>);
    };

    return (
        <SegmentLoader
            isLoading={
                isLoading ||
                isLoadingRenseignerPiecesIdentite ||
                isLoadingApiCreerCompteAdresse ||
                isLoadingCarteCollectionneur
            }
        >
            {erreur && message && (
                <Row>
                    <Col col={12}>
                        <div className="fr-error">{renderMessage(message)}</div>
                    </Col>
                </Row>
            )}

            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <CompteIdentiteChamps
                        hasEmailPro
                        hasTelephone
                        titre={
                            statutMetierAsso === KEY_DETENTEUR_METIER_PHYSIQUE
                                ? 'Identité du détenteur métier physique'
                                : 'Identité du responsable légal'
                        }
                    />

                    {IS_COLLECTIONNEUR_MORALE && (
                        <ChampsCarteCollectionneur validateDate={validateDate} />
                    )}

                    <CreerCompteAdresse
                        motifs={motifs}
                        renderFormProvider={false}
                        afficherInformations={false}
                        uuidBrouillon={uuidBrouillon}
                        dataAdressePrincipaleRenseignee={dataIdentiteMetierAsso}
                        isAncienLicencie={false}
                        setSuccessSubmit={setIsSuccessSubmitCreerCompteAdresse}
                        onLoadingChange={setIsLoadingApiCreerCompteAdresse}
                    />

                    <Row className="margin-top-lg">
                        <Col>
                            <ButtonGroup inline align="right">
                                <Button
                                    name="etapePrecedente"
                                    variant="secondary"
                                    type="button"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerPiecesIdentite ||
                                        isLoadingPermisDeChasse ||
                                        isLoadingValidationPermisChasser ||
                                        isLoadingVersoLicenceSki ||
                                        isLoadingVersoLicenceBallTrap ||
                                        isLoadingCarteCollectionneur
                                    }
                                    onClick={retourEtape}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="etapeSuivante"
                                    variant="primary"
                                    type="submit"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerPiecesIdentite ||
                                        isLoadingPermisDeChasse ||
                                        isLoadingValidationPermisChasser ||
                                        isLoadingVersoLicenceSki ||
                                        isLoadingVersoLicenceBallTrap ||
                                        isLoadingCarteCollectionneur
                                    }
                                    disabled={!hasFormValid()}
                                >
                                    Accéder à l'étape suivante
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

CreerCompteIdentiteMetierAsso.propTypes = {
    statutCompteMetierAsso: PropTypes.shape({
        statut: PropTypes.string,
        typeMetierAssociation: PropTypes.string,
    }),
    statutMetierAsso: PropTypes.string,
    postApi: PropTypes.func.isRequired,
    setEtapeIdentiteMetierAsso: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    data: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    dataCodePostal: PropTypes.object,
    message: PropTypes.string,
    isLoadingRenseignerPiecesIdentite: PropTypes.bool,
    erreurRenseignerPiecesIdentite: PropTypes.bool,
    dataRenseignerPiecesIdentite: PropTypes.string.isRequired,
    isLoadingPermisDeChasse: PropTypes.bool,
    erreurPermisDeChasse: PropTypes.bool,
    dataRenseignerPermisDeChasse: PropTypes.string.isRequired,
    isLoadingValidationPermisChasser: PropTypes.bool,
    erreurValidationPermisChasser: PropTypes.bool,
    dataRenseignerValidationPermisChasser: PropTypes.string.isRequired,
    erreurVersoLicenceSki: PropTypes.bool,
    isLoadingVersoLicenceSki: PropTypes.bool,
    dataRenseignerVersoLicenceSki: PropTypes.string.isRequired,
    erreurVersoLicenceBallTrap: PropTypes.bool,
    isLoadingVersoLicenceBallTrap: PropTypes.bool,
    dataRenseignerVersoLicenceBallTrap: PropTypes.string.isRequired,
    erreurVersoLicenceTir: PropTypes.bool,
    isLoadingVersoLicenceTir: PropTypes.bool,
    dataRenseignerVersoLicenceTir: PropTypes.string.isRequired,
    isLoadingCarteCollectionneur: PropTypes.bool,
    erreurCarteCollectionneur: PropTypes.bool,
    dataRenseignerCarteCollectionneur: PropTypes.string.isRequired,
    setEtapeIdentite: PropTypes.func.isRequired,
    setAncienLicencie: PropTypes.func.isRequired,
    dataIdentiteMetierAsso: PropTypes.shape({
        dateNaissance: PropTypes.string,
        lieuNaissance: PropTypes.string,
        idNationalite: PropTypes.number,
        idPaysNaissance: PropTypes.number,
        nom: PropTypes.string,
        nomUsage: PropTypes.string,
        numeroPermisChasseur: PropTypes.string,
        numeroLicenceBallTrap: PropTypes.string,
        numeroLicenceSki: PropTypes.string,
        numeroLicenceTir: PropTypes.string,
        versoLicenceTir: PropTypes.instanceOf(FileUploadeAbstract),
        versoLicenceSki: PropTypes.instanceOf(FileUploadeAbstract),
        versoLicenceBallTrap: PropTypes.instanceOf(FileUploadeAbstract),
        selectLicencieOrAncienLicencieBallTrap: PropTypes.string,
        selectLicencieOrAncienLicencieSki: PropTypes.string,
        selectLicencieOrAncienLicencieTir: PropTypes.string,
        prenomUn: PropTypes.string,
        prenomDeux: PropTypes.string,
        prenomTrois: PropTypes.string,
        prenomQuatre: PropTypes.string,
        prenomUsuel: PropTypes.string,
        sexe: PropTypes.string,
        numeroPieceIdentite: PropTypes.string,
        typePieceIdentite: PropTypes.string,
        piecesIdentite: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),
        numeroGuichetUnique: PropTypes.instanceOf(FileUploadeAbstract),
        validationPermisChasser: PropTypes.instanceOf(FileUploadeAbstract),
        numeroSia: PropTypes.string,
        dateDelivrance: PropTypes.string,
        numeroCarteCollectionneur: PropTypes.string,
        dateDelivranceCarteCollectionneur: PropTypes.string,
        carteCollectionneur: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),

        numeroDeVoie: PropTypes.string,
        typeEtNomDeVoie: PropTypes.string.isRequired,
        extension: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string.isRequired,
        ville: PropTypes.string.isRequired,
        typeJustificatif: PropTypes.string.isRequired,
        justificatifsDomicile: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract))
            .isRequired,
        certificatMedical: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract)),
        itinerant: PropTypes.string,
        immatriculationVehicule: PropTypes.string,
        email: PropTypes.string,
        telephonePrincipal: PropTypes.string,
        telephoneSecondaire: PropTypes.string,
    }),
    uuidBrouillon: PropTypes.string,
    motifs: PropTypes.object.isRequired,
    retourEtape: PropTypes.func.isRequired,
    featureFlipping: PropTypes.object.isRequired,
    clearAlertes: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { isLoading, erreur, message, data } = state.compte.creer.renseignerIdentite;
        const { statutCompteMetierAsso } = state.compte.creer;
        const {
            data: dataRenseignerPiecesIdentite,
            isLoading: isLoadingRenseignerPiecesIdentite,
            erreur: erreurRenseignerPiecesIdentite,
        } = state.compte.creer.renseignerPiecesIdentite;
        const {
            data: dataRenseignerPermisDeChasse,
            isLoading: isLoadingPermisDeChasse,
            erreur: erreurPermisDeChasse,
        } = state.compte.creer.renseignerPermisDeChasse;
        const {
            data: dataRenseignerValidationPermisChasser,
            isLoading: isLoadingValidationPermisChasser,
            erreur: erreurValidationPermisChasser,
        } = state.compte.creer.renseignerValidationPermisChasser;
        const {
            data: dataRenseignerVersoLicenceSki,
            isLoading: isLoadingVersoLicenceSki,
            erreur: erreurVersoLicenceSki,
        } = state.compte.creer.renseignerVersoLicenceSki;
        const {
            data: dataRenseignerVersoLicenceBallTrap,
            isLoading: isLoadingVersoLicenceBallTrap,
            erreur: erreurVersoLicenceBallTrap,
        } = state.compte.creer.renseignerVersoLicenceBallTrap;
        const {
            data: dataRenseignerVersoLicenceTir,
            isLoading: isLoadingVersoLicenceTir,
            erreur: erreurVersoLicenceTir,
        } = state.compte.creer.renseignerVersoLicenceTir;
        const {
            data: dataRenseignerCarteCollectionneur,
            isLoading: isLoadingCarteCollectionneur,
            erreur: erreurCarteCollectionneur,
        } = state.compte.creer.renseignerCarteCollectionneur;

        const { data: dataCodePostal } = state.monCompte.verifierCodePostal;

        return {
            statutCompteMetierAsso,
            isLoading,
            erreur,
            data,
            message,
            dataRenseignerPiecesIdentite,
            isLoadingRenseignerPiecesIdentite,
            erreurRenseignerPiecesIdentite,
            dataRenseignerPermisDeChasse,
            isLoadingPermisDeChasse,
            erreurPermisDeChasse,
            dataRenseignerValidationPermisChasser,
            isLoadingValidationPermisChasser,
            erreurValidationPermisChasser,
            dataRenseignerVersoLicenceSki,
            isLoadingVersoLicenceSki,
            erreurVersoLicenceSki,
            dataRenseignerVersoLicenceBallTrap,
            isLoadingVersoLicenceBallTrap,
            erreurVersoLicenceBallTrap,
            dataRenseignerVersoLicenceTir,
            isLoadingVersoLicenceTir,
            erreurVersoLicenceTir,
            dataRenseignerCarteCollectionneur,
            isLoadingCarteCollectionneur,
            erreurCarteCollectionneur,
            dataCodePostal,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
        clearAlertes: hideAllNotification,
    },
)(CreerCompteIdentiteMetierAsso);
